export function s2rc(coord : string) : {row : number, col : number} {
  const [row, col] = coord.split(",").map(n => Number.parseInt(n));
  return {row, col};
}

export function rc2s(row : number, col : number) : string {
  return `${row},${col}`;
}

export function offset(coord : string, [rowO, colO] : [number, number]) : string {
  const {row, col} = s2rc(coord);
  return rc2s(row + rowO, col + colO);
}

export function byRC([as,] : [string, string], [bs,] : [string, string]) : number {
  const a = s2rc(as);
  const b = s2rc(bs);

  if (a.row < b.row) return -1;
  if (a.row > b.row) return +1;
  if (a.col < b.col) return -1;
  if (a.col > b.col) return +1;
  return 0;
}

export function byValue([, a] : [string, string], [, b] : [string, string]) : number {
  if (a < b) return -1;
  if (a > b) return +1;
  return 0;
}